// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* .footer {
  height: 50px;
} */
[dir="ltr"] .social-icon-container {
  margin-right: 11px;
}

[dir="rtl"] .social-icon-container {
  margin-left: 11px;
}

/* Footer.css */
.footer-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px;
  background-color: #333;
}

.text-blocks {
  display: flex;
  flex-wrap: wrap; /* Permet aux éléments de s'enrouler à l'écran étroit */
  justify-content: space-around;
  width: 100%;
}

.text-block {
  width: 100%;
  padding: 10px;
  background-color: #333;
  color: #fff;
  margin-bottom: 10px; /* Ajoute un espace entre les blocs de texte */
}

.social-icons {
  display: flex;
  margin-top: 20px;
}

/* Style des liens */
.social-icon {
  font-size: 48px;
  color: #007bff;
  transition: color 0.2s;
}

[dir="ltr"] .social-icon:last-child {
  margin-right: 0;
}

[dir="rtl"] .social-icon:last-child {
  margin-left: 0;
}

.social-icon:hover {
  color: #ecf0f1;
}

.pic-of-me {
  width: 12.56%;
  border-radius: 50%;
  background-color: white; /* Fond blanc */
  padding: 6px; /* Espace entre image et fond */
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); /* Optionnel : léger effet d'élévation */
}

.text_white {
  color: #28b463;
}

.text_white:hover {
  color: #abebc6;
}

.text_grey {
  color: #117864;
}

.text_grey:hover {
  color: #28b463;
}

/* Media Query pour les petits écrans (smartphones) */
@media screen and (max-width: 768px) {
  .text-blocks {
    display: inline;
  }

  .pic-of-me {
    width: 20%;
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/footer/footer.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;GAAA;AAGA;EACE,kBAAA;AAEF;;AAHA;EACE,iBAAA;AAEF;;AACA,eAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAEF;;AACA;EACE,aAAA;EACA,eAAA,EAAA,uDAAA;EACA,6BAAA;EACA,WAAA;AAEF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA,EAAA,8CAAA;AACF;;AAEA;EACE,aAAA;EAEA,gBAAA;AAAF;;AAGA,oBAAA;AACA;EACE,eAAA;EACA,cAAA;EACA,sBAAA;AAAF;;AAIA;EACE,eAAA;AADF;;AAAA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,aAAA;EACA,kBAAA;EACA,uBAAA,EAAA,eAAA;EACA,YAAA,EAAA,+BAAA;EACA,sCAAA,EAAA,wCAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAEA;EACE,cAAA;AACF;;AAEA,qDAAA;AACA;EACE;IACE,eAAA;EACF;;EAGA;IACE,UAAA;EADF;AACF","sourcesContent":["/* .footer {\n  height: 50px;\n} */\n.social-icon-container {\n  margin-right: 11px; /* Ajoutez la marge désirée entre les icônes */\n}\n\n/* Footer.css */\n.footer-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 20px;\n  background-color: #333;\n}\n\n.text-blocks {\n  display: flex;\n  flex-wrap: wrap; /* Permet aux éléments de s'enrouler à l'écran étroit */\n  justify-content: space-around;\n  width: 100%;\n  // max-width: 800px;\n}\n\n.text-block {\n  width: 100%;\n  padding: 10px;\n  background-color: #333;\n  color: #fff;\n  margin-bottom: 10px; /* Ajoute un espace entre les blocs de texte */\n}\n\n.social-icons {\n  display: flex;\n  //justify-content: space-between;\n  margin-top: 20px;\n}\n\n/* Style des liens */\n.social-icon {\n  font-size: 48px;\n  color: #007bff;\n  transition: color 0.2s;\n  //  margin-right: 36px; /* Tripler l'espace entre les icônes */\n}\n\n.social-icon:last-child {\n  margin-right: 0; /* Supprimer la marge à droite de la dernière icône */\n}\n\n.social-icon:hover {\n  color: #ecf0f1;\n}\n\n.pic-of-me {\n  width: 12.56%;\n  border-radius: 50%;\n  background-color: white; /* Fond blanc */\n  padding: 6px; /* Espace entre image et fond */\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); /* Optionnel : léger effet d'élévation */\n}\n\n.text_white {\n  color: #28b463;\n}\n.text_white:hover {\n  color: #abebc6;\n}\n\n.text_grey {\n  color: #117864;\n}\n.text_grey:hover {\n  color: #28b463;\n}\n\n/* Media Query pour les petits écrans (smartphones) */\n@media screen and (max-width: 768px) {\n  .text-blocks {\n    display: inline;\n    // width: 100%; /* Les blocs de texte occuperont 100% de largeur sur les petits écrans */\n  }\n\n  .pic-of-me {\n    width: 20%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
